import { FunctionComponent } from "react";

import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

import { IconDefinition } from "@fortawesome/fontawesome-common-types";

import { faEnvelope } from "@fortawesome/pro-solid-svg-icons";

import { Icon } from "@/components";
import { BrandsIcon } from "@/components/BrandsIcon/BrandsIcon";

import { Conversation } from "@/pages/Private/pages/Apollo/schema/get-people";

/**
 * A single round badge in the inbox lead card's gutter, indicating which channel the last reply
 * arrived on. LinkedIn replies (`message_received`) render the LinkedIn glyph; every other
 * inbound reply (`mail_received`) renders the envelope. Returns `null` when there is no reply.
 */
export const ReplyChannelBadge: FunctionComponent<{ lastResponse?: Conversation }> = ({
	lastResponse,
}) => {
	if (!lastResponse) {
		return null;
	}

	const isLinkedin =
		lastResponse.type === "message_received" || Boolean(lastResponse.receiverLinkedinUrl);

	return (
		<div
			aria-label={isLinkedin ? "linkedin reply" : "email reply"}
			className={`flex h-[24px] w-[24px] shrink-0 items-center justify-center rounded-full text-white ${
				isLinkedin ? "bg-brand-linkedin" : "bg-blue-action"
			}`}
		>
			{isLinkedin ? (
				<BrandsIcon className="h-3 w-3" icon={faLinkedinIn as IconDefinition} />
			) : (
				<Icon className="h-3 w-3" icon={faEnvelope} />
			)}
		</div>
	);
};
